import { Component, Input, inject } from '@angular/core';
import { CartService, CartQuery, CartV2Query, PortalProduct, CartV2Service } from '@fgb/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'fgb-subscriptions-list-item',
  templateUrl: './subscriptions-list-item.component.html',
  styleUrls: ['./subscriptions-list-item.component.scss'],
})
export class SubscriptionsListItemComponent {
  @Input() portalProduct: PortalProduct;
  currentLcid: string | null = '';

  private readonly cartV2Query = inject(CartV2Query);

  constructor(
    private modalService: NgbModal,
    private cartService: CartService,
    private cartQuery: CartQuery,
    private cartV2Service: CartV2Service
  ) {
    this.currentLcid = localStorage.getItem('lcid');
  }

  addSubscriptionProductToCart() {
    // One membership at a time, and one of any given subscription: the V1
    // basket refuses a second either way, and the V2 basket has to agree or
    // the two carts disagree about what is being bought.
    const alreadyInBasket =
      this.portalProduct.ProductType === 1 ? this.checkBasketForMembership() : this.checkBasketForSubs();

    if (alreadyInBasket) {
      return;
    }

    this.cartService.addPortalProductToCart(this.portalProduct);

    // Guarded separately against the V2 basket. This used to sit outside the
    // check entirely, so it ran even when V1 had refused the item - and V2's
    // upsert has no duplicate check of its own for portal products, so each
    // press added another row.
    if (!this.checkV2BasketForProduct()) {
      this.cartV2Service.addItemToCart(this.portalProduct, 1);
    }
  }

  openProductDescription(content: any) {
    this.modalService.open(content, { centered: true });
  }

  private checkBasketForMembership(): boolean {
    return this.cartQuery.getMemberPortalProductCart().some((item) => (item.productData as PortalProduct).ProductType === 1);
  }

  private checkBasketForSubs(): boolean {
    return this.cartQuery
      .getMemberPortalProductCart()
      .some(
        (item) =>
          (item.productData as PortalProduct).ProductType === 3 &&
          (item.productData as PortalProduct).ProductId === this.portalProduct.ProductId
      );
  }

  /**
   * Whether the V2 basket already holds this product.
   *
   * Matched on ProductId: a portal product has no Id, which is the field
   * CartV2Service looks an existing line up by - so its own duplicate check
   * never matches one and cannot be relied on here.
   */
  private checkV2BasketForProduct(): boolean {
    return this.cartV2Query
      .summary()
      .productItems.items.some((item) => item.productData.ProductId === this.portalProduct.ProductId);
  }
}
